<template>
  <div class="current-time">{{ currentTime }}</div>
</template>

<script>
import Time from '../helpers/Time'

export default {
  props: {
    store: {
      type: Object,
      default: function () {}
    }
  },
  computed: {
    currentTime () {
      return Time.iso(this.store.state.currentTime)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

.current-time {
  background: rgba($yellow-200, .95);
  border-radius: 2px;
  color: $black-800;
  height: 16px;
  margin: -8px 0 0 8px;
  padding: 0 5px;
  top: 50%;
  position: absolute;
  z-index: 4;

  @include font-xs();

  font-size: .6428rem;
}
</style>
